// extracted by mini-css-extract-plugin
module.exports = {"inputMessage":"AddMessageChateTwo_inputMessage__Lhbw3","inputText":"AddMessageChateTwo_inputText__FbFyL","buttonInput":"AddMessageChateTwo_buttonInput__2Jxgi"};